export var Entitlement;
(function (Entitlement) {
    Entitlement["AuthorisedSignatory"] = "AUTHORISED_SIGNATORY";
    Entitlement["DelegatedSignatory"] = "DELEGATED_SIGNATORY";
})(Entitlement || (Entitlement = {}));
